import type { Fallacy } from "./types";
import { createStory } from "./types";

export const bandwagon: Fallacy = {
    id: "bandwagon",
    name: "Bandwagon",
    emoji: "🚂",
    category: "Manipulasi Emosi & Sosial",
    description:
      "Berargumen bahwa sesuatu benar hanya karena **banyak orang** yang melakukan atau mempercayainya.",
    detail:
      "Bandwagon Fallacy (Ad Populum) adalah argumen bahwa sesuatu pasti benar karena **banyak orang** mempercayainya. \"Semua orang melakukannya\" bukan bukti kebenaran — dulu semua orang percaya bumi datar, tetap saja salah.\n\nOtak kita rentan karena manusia punya kecenderungan alami mengikuti mayoritas (**herd mentality**). Berguna di zaman purba, tapi menyesatkan di era informasi.\n\n**Popularitas ≠ kebenaran.** Keputusan terbaik didasarkan pada bukti dan analisis, bukan pada apa yang sedang 'trending'.",
    tldr: "Semua orang ikutan, berarti bener? Ya gak gitu juga kali.",
    story: createStory("Bandwagon", "🚂", {
      hook: {
        title: "\"Semua orang udah ikutan!\"",
        body: "Dulu semua orang percaya bumi datar — tetap aja salah. **Rame bukan berarti bener.**",
      },
      convo: {
        claim: "50 juta orang udah invest crypto. **Masa kamu mau ketinggalan?** Semua orang udah pada cuan!",
        response: "Jumlah orang yang ikutan **bukan bukti itu keputusan yang bagus.**",
      },
      reveal: {
        body: "Nganggep sesuatu **pasti bener karena banyak yang ikutan**. Otak kita emang rentan — naluri ikut mayoritas dari zaman purba.",
      },
      insight: {
        title: "Kenapa kita gampang ketipu?",
        body: "Otak kita **emang didesain ikut mayoritas** — naluri dari zaman purba. Tapi di era sekarang, rame bukan berarti bener.",
      },
      engagement: {
        title: "Pernah ikut-ikutan tren yang ternyata zonk?",
        body: "Crypto, skincare viral, atau MLM? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["appeal-to-authority", "appeal-to-emotion", "hasty-generalization"],
  };
